<template>
  <div class="app-container">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span><i class="el-icon-lock"></i> 权限管理</span>
      </div>

      <!-- 新增按钮 -->
      <el-row style="margin-bottom: 10px">
        <el-button type="primary" icon="el-icon-plus" @click="handleAdd"
          >新增</el-button
        >
      </el-row>

      <!-- 表格 -->
      <el-table
        :cell-style="{ textAlign: 'center' }"
        :header-cell-style="{
          background: '#f5f7fa',
          color: '#333',
          fontWeight: 'bold',
          textAlign: 'center',
        }"
        :data="tableData"
        style="width: 100%"
        border
      >
        <el-table-column prop="parentName" label="父级" />
        <el-table-column prop="name" label="名称" />
        <el-table-column label="状态">
          <template slot-scope="scope">
            {{ scope.row.state === 0 ? "隐藏" : "正常" }}
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleEdit(scope.row)"
              >编辑</el-button
            >
            <el-button
              size="mini"
              type="danger"
              @click="handleDelete(scope.row)"
              :disabled="Number(scope.row.id) === 1"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <pagination-bar
        :total="total"
        :page-size="pageSize"
        :current-page="currentPage"
        @update:pageSize="pageSize = $event"
        @update:currentPage="currentPage = $event"
        @page-change="fetchData"
      />

      <!-- 弹窗表单 -->
      <el-dialog
        @close="handleDialogClose"
        :visible.sync="dialogVisible"
        title="权限设置"
        width="800px"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <el-form :model="form" label-width="100px" :rules="rules" ref="formRef">
          <el-form-item label="父级" prop="parentId">
            <el-select
              v-model="form.parentId"
              placeholder="请选择父级菜单"
              style="width: 400px"
            >
              <el-option
                v-for="item in parentOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>

          <el-form-item label="名称" prop="name">
            <el-input v-model="form.name" style="width: 400px" />
          </el-form-item>

          <el-form-item label="权限" required>
            <el-row>
              <el-col :span="10">
                <div>前端权限</div>
                <el-tree
                  :data="frontendPermissions"
                  show-checkbox
                  node-key="id"
                  :default-checked-keys="[]"
                  ref="frontendTree"
                  :props="treeProps"
                />
              </el-col>
              <el-col :span="10">
                <div>后端权限</div>
                <el-tree
                  :data="backendPermissions"
                  show-checkbox
                  node-key="id"
                  :default-checked-keys="[]"
                  ref="backendTree"
                  :props="treeProps"
                />
              </el-col>
            </el-row>
          </el-form-item>

          <el-form-item label="状态" prop="state">
            <el-radio-group v-model="form.state">
              <el-radio :label="1">正常</el-radio>
              <el-radio :label="0">隐匿</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>

        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="submitForm">确定</el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import {
  rolePage,
  roleAddOrEdit,
  roleDelete,
  roleDetail,
  findAll,
} from "@/api/config";
import { MAX_PAGE_SIZE } from "@/utils/const";
import { buildHierarchy } from "@/utils/util";
import PaginationBar from "@/components/PaginationBar";

export default {
  name: "PermissionManagement",
  components: {
    PaginationBar,
  },
  data() {
    return {
      isEdit: false, //
      treeProps: {
        label: "name",
        children: "children",
      },
      tableData: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      dialogVisible: false,
      form: {
        parentId: "",
        name: "",
        state: "",
        frontendPerms: [],
        backendPerms: [],
      },
      rules: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        parentId: [{ required: true, message: "请选择父级", trigger: "blur" }],
        state: [{ required: true, message: "请选择状态", trigger: "blur" }],
      },
      parentOptions: [],
      frontendPermissions: [],
      // 后端权限：路由访问
      backendPermissions: [],
    };
  },
  methods: {
    handleDialogClose() {
      // 重置表单校验状态
      this.$refs.formRef.resetFields();

      // 重置表单数据
      this.form = {
        parentId: "",
        name: "",
        state: "",
        frontendPerms: [],
        backendPerms: [],
      };

      // 清空树形控件的选中状态
      if (this.$refs.frontendTree) {
        this.$refs.frontendTree.setCheckedKeys([]);
      }
      if (this.$refs.backendTree) {
        this.$refs.backendTree.setCheckedKeys([]);
      }
    },
    handleAdd() {
      this.isEdit = false;
      this.dialogVisible = true;
      this.$nextTick(() => this.$refs.formRef.resetFields());
    },
    handleEdit(row) {
      this.isEdit = true;
      this.dialogVisible = true;
      // 请求详情
      roleDetail({ id: row.id }).then((res) => {
        this.form = res;
        this.$nextTick(() => {
          this.$refs.backendTree.setCheckedKeys(res.adminPermissionIds);
          this.$refs.frontendTree.setCheckedKeys(res.userPermissionIds);
        });
      });
    },
    handleDelete(row) {
      this.$confirm("确认删除该权限?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          roleDelete({ id: row.id }).then(() => {
            this.$message.success("删除成功！");
            this.fetchData();
          });
        })
        .catch(() => {
          this.$message.info("已取消删除");
        });
    },
    getOptions() {
      rolePage({
        pageNo: 1,
        pageSize: MAX_PAGE_SIZE,
      }).then((res) => {
        this.parentOptions = res.records;
      });
    },
    findAllFun() {
      // 查询所有的权限
      findAll().then((res) => {
        this.frontendPermissions = buildHierarchy(res.userPermissions);
        this.backendPermissions = buildHierarchy(res.adminPermissions);
      });
    },
    fetchData(page) {
      this.currentPage = page || 1;
      rolePage({
        pageNo: this.currentPage,
        pageSize: this.pageSize,
      }).then((res) => {
        this.tableData = res.records;
        this.total = res.total;
      });
    },
    submitForm() {
      this.$refs.formRef.validate((valid) => {
        if (!valid) return;

        // 校验通过，进行权限数据校验
        const frontendTree = this.$refs.frontendTree;
        const backendTree = this.$refs.backendTree;

        if (frontendTree && backendTree) {
          const frontendSelected = frontendTree.getCheckedKeys().length || 0;
          const backendSelected = backendTree.getCheckedKeys().length || 0;

          // 校验前端和后端权限是否都没有选中
          if (frontendSelected === 0 && backendSelected === 0) {
            return this.$message.error("请至少选择一个前端或后端权限");
          }

          const checkedNodesFrontend = frontendTree.getCheckedNodes(); // 获取所有选中的节点
          const checkedNodesBackend = backendTree.getCheckedNodes(); // 获取所有选中的节点

          const checkedIdsFrontend = checkedNodesFrontend.map(
            (node) => node.id
          );
          const checkedIdsackend = checkedNodesBackend.map((node) => node.id);

          // 去重（如果有重复的 id）
          const permissionIds = {
            userPermissionIds: [...new Set(checkedIdsFrontend)],
            adminPermissionIds: [...new Set(checkedIdsackend)],
          };

          const params = {
            name: this.form.name,
            parentId: this.form.parentId,
            state: this.form.state,
            ...permissionIds,
          };
          if (this.isEdit) {
            params.id = this.form.id;
          }

          roleAddOrEdit(params).then(() => {
            this.dialogVisible = false;
            this.fetchData();
            this.$message.success("操作成功");
          });
        }
      });
    },
  },
  mounted() {
    this.fetchData();
    this.getOptions();
    this.findAllFun();
  },
};
</script>

<style scoped>
.app-container {
}
.vertical-item ::v-deep .el-form-item__content {
  display: block;
}
</style>
